// Import React Components
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import { makeStyles, Breadcrumbs, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { asmTempState, openListState } from '../../../recoil-store/recoil-state';
import { useRecoilState } from 'recoil';

// Import CSS Files
import './breadcrumb.css';

const useStyles = makeStyles({
    breadcrumb: {
        position: 'absolute',
        left: '230px',
        top: 20,
        width: 'calc(100% - 258px)',
        color: 'black',
        borderRadius: '5px',
        boxShadow: '0px 0px 8px -3px rgba(0, 0, 0, 0.25)',
        transition: 'left 0.25s',
        height: '27px'
    },
    close: {
        left: "115px !important",
        width: 'calc(100% - 145px) !important'
    },
    breadcrumbItem: {
        color: 'gray',
        zIndex: 1500
    }
});

const Breadcrumb = ({ sideBarOpen }) => {
    const [routeString, setRouteString] = useState([])
    const classes = useStyles();
    const [asmTemp, setAsmTemp] = useRecoilState(asmTempState);
    const [openList, setOpenList] = useRecoilState(openListState);
    const { t } = useTranslation();

    useEffect(() => {
        setRouteString(window.location.pathname.split('/').filter((x) => x));
    }, [window.location.pathname]);

    const handleLink = () => {
        if (openList === "dashboard") {
            setOpenList(false);
        }
        let { parent, child, thirdChild } = asmTemp
        parent = 1;
        child = 11;
        setAsmTemp({ parent, child, thirdChild });
    }
    const checkLink = (value) => {
        if (["user-management", "vault", "webhook-api", "alert-management", "settings"].includes(value)) {
            return false
        }
        return true
    }

    return (
        <Breadcrumbs
            className={sideBarOpen ? classes.breadcrumb : `${classes.breadcrumb} ${classes.close}`}
            id="breadcrumb-item" separator={<NavigateNextIcon className="breadcrumb-item-next-icon" />}
            data-test="breadcrumb"
        >
            {/* <Link className="breadcrumb-item-old" to="/dashboard/panel" onClick={handleLink}>{t('CONTENT.BREADCRUMB.HOME')}</Link> */}
            {routeString.map((value, index) => {
                if (routeString[index + 1] === "edit" && /\d/.test(value)) return;
                let last = index === routeString.length - 1;
                let to = `${routeString.slice(0, index + 1).join('/')}`;

                // Check for have a page for the link or not if not link will be disabled.
                const isOkToLink = checkLink(value)

                // Adding translation addon in front of to variable of 'to'
                let newTo = 'CONTENT.BREADCRUMB.' + value.toUpperCase();
                // This section is doing a kind of validation for breadcrumb links if the pathname has an integer, it's exclude them.
                if (/\d/.test(value)) {
                    newTo = t('CONTENT.BREADCRUMB.DETAILS');
                }
                return last ? (
                    <Typography className="breadcrumb-item-selected" key={to}>{t(newTo)}
                        <span className="breadcrumb-line" />
                    </Typography>
                ) : (
                    !isOkToLink ? <div className={`breadcrumb-item-old disabled-link`}>{t(newTo)}</div> : to !== "dashboard" && to !== "my-environment" && to !== "store" && to !== "management"
                        ? <Link className={`breadcrumb-item-old inactive ${to ? "to" : ""}`} to={to} key={to}>{t(newTo)}</Link> : ""
                );
            })}
        </Breadcrumbs >
    );
};
export default Breadcrumb;
